import {useRef} from 'react'
type uploadFilesprops = {
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>
  fileTypes: string
  labelText: string
  buttontext: string
  isMultiple: boolean
}
export const UploadFiles = ({
  setUploadedFiles,
  fileTypes,
  labelText,
  buttontext,
  isMultiple,
}: uploadFilesprops) => {
  const inputRef: any = useRef<any>(null)
  return (
    <>
      <button
        className='btn btn-bg-primary btn-color-white'
        onClick={(e) => {
          e.stopPropagation()
          inputRef?.current.click()
        }}
      >
        {buttontext}
      </button>
      <div>{labelText}</div>
      {/* Hide the crappy looking default HTML input */}
      <input
        ref={inputRef}
        type='file'
        multiple={isMultiple}
        accept={fileTypes}
        onClick={(e) => {
          e.stopPropagation()
        }}
        style={{display: 'none'}}
        onChange={(e: any) => {
          let canUpload = true
          if (canUpload) {
            setUploadedFiles((prev) => {
              return [...prev, ...e.target.files]
            })
          }
        }}
      />
    </>
  )
}
